import { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import SideMenu from "./SideMenu";
import NavBar from "./NavBar";
import MainSection from "./MainSection";
import Footer from "./Footer";
import NotificationSnackbar from "../NotificationSnackbar";
import { LAYOUT_DIMENSIONS } from "../../utils/Constants";
import "./Layout.scss";

const Layout = () => {
  const [mobileSideMenuOpen, setMobileSideMenuOpen] = useState(false);

  const detectMobileSideMenuOpen = (isOpen) => {
    setMobileSideMenuOpen(isOpen);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f6f6f6"
      }}>
      <NavBar
        drawerWidth={LAYOUT_DIMENSIONS.drawerWidth}
        openMobileSideMenu={detectMobileSideMenuOpen}
        navbarHeight={LAYOUT_DIMENSIONS.navbarHeight}
      />
      <SideMenu
        closeMobileSideMenu={() => detectMobileSideMenuOpen(false)}
        drawerWidth={LAYOUT_DIMENSIONS.drawerWidth}
        navbarHeight={LAYOUT_DIMENSIONS.navbarHeight}
        footerHeight={LAYOUT_DIMENSIONS.footerHeight}
        mobileSideMenuOpen={mobileSideMenuOpen}
      />
      <MainSection
        drawerWidth={LAYOUT_DIMENSIONS.drawerWidth}
        navbarHeight={LAYOUT_DIMENSIONS.navbarHeight}
        footerHeight={LAYOUT_DIMENSIONS.footerHeight}>
        <Outlet />
      </MainSection>
      <Footer footerHeight={LAYOUT_DIMENSIONS.footerHeight} />
      <NotificationSnackbar />
    </Box>
  );
};

export default Layout;
